import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import DebugSnapshotPage from '~/debug/DebugSnapshotPage';

export const Route = createFileRoute('/debug/$snapshotId')({
  component: DebugSnapshotRoute,
});

function DebugSnapshotRoute() {
  const { snapshotId } = Route.useParams();
  return <DebugSnapshotPage snapshotId={snapshotId} />;
}
